/** @jsx jsx */
import { jsx } from '@emotion/core';
import * as React from 'react';
import { css } from 'emotion';
import { PlusIcon } from '../../../../ui/icons';
//@ts-ignore
import TaxSection from './PayoffTaxFormComponents/TaxSection';
import { minus, plusButton, sectionDivStyles } from '../PayoffTaxObjectsAndStyles';
import { SplitTaxCollected } from '../types';
import { usePayoffTaxSearch } from '../PayoffTaxSearchContext';
import ClosedSection from './ClosedSection';

interface Props {
  createNewExemptionHandler: (newExemption: string, taxIndex: number, i: number) => void;
  scrollToMyRef: () => void;
}
function PropertyTaxSections(props: Props) {
  const { propertyTaxes, sectionOpen, setSectionOpen, removePropertyTaxSection } = usePayoffTaxSearch();
  return (
    <React.Fragment>
      {propertyTaxes.map((pt: SplitTaxCollected, taIndex: number) => (
        <div className={css(sectionDivStyles)} key={`propertyTaxes${pt.id}`} id={`propertyTaxes[${taIndex}]`}>
          {sectionOpen === `propertyTaxes[${taIndex}]` ? (
            <React.Fragment>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2>{pt.taxDescriptionType.type}</h2>
                <button css={plusButton} onClick={() => setSectionOpen(!sectionOpen)}>
                  {sectionOpen ? <span css={minus} /> : <PlusIcon />}
                </button>
              </div>
              <TaxSection taxDetails={pt} taxIndex={taIndex} />
            </React.Fragment>
          ) : (
            <ClosedSection
              removeSection={() => removePropertyTaxSection(taIndex)}
              setSectionOpen={() => setSectionOpen(`propertyTaxes[${taIndex}]`)}
              type={pt.taxDescriptionType.type}
              scrollToMyRef={props.scrollToMyRef}
            />
          )}
        </div>
      ))}
    </React.Fragment>
  );
}

export default PropertyTaxSections;
